<template>
  <div class="content-container">
    <ProductSearch @onSearch="onSearch" @onReset="onReset" />
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-select-first-row="false"
        :auto-size-cell="false"
        :row-multi-select-with-click="true"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        :page-size="searchParams.pageSize"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="selectedRows.length == 0"
        class="btn primary small outline"
        @click="deleteProduct"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length !== 1"
        class="btn primary small"
        @click="editProduct"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openAddProductDialog">
        {{ $t('button.add') }}
      </button>
      <button class="btn primary small" @click="openUploadByExcelDialog()">
        {{ $t('button.uploadFromExcel') }}
      </button>
      <button class="btn primary small" @click="downloadProductList">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <upload-by-excel-component
      ref="uploadByExcelComponent"
      @uploadSuccess="attachData()"
    />
    <!-- <el-dialog
      :visible.sync="addListExcelDialogVisible"
      :title="isEdit ? $t('dialog.productUpdate') : $t('dialog.productAdd')"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div class="das-info-title mt-0 mb-10">
        Danh sách lỗi khi nhập dữ liệu bằng Excel
      </div>
      <div style="height: 300px">
        <GridVx
          ref="agGrid"
          :columns="errorExcelUploadCols"
          :rows="errorExcelUploadRows"
          class="agGrid"
          :context="context"
          dom-layout="scroll"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addListExcelDialogVisible = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="getListTemplate">
            Tải mẫu
          </button>
          <FileInput
            ref="uploadFile"
            title="Chọn tệp tin"
            @onSelectFile="onSelectUploadList"
          />
        </div>
      </span>
    </el-dialog> -->
    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="isEdit ? 'Sửa sản phẩm' : 'Thêm sản phẩm'"
      width="1000px"
      :close-on-click-modal="false"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12 flex justify-center">
                <!-- <avatar-upload
                  ref="imgUpload"
                  :img-src="productItem.picture"
                  :is-edit-mode="true"
                  @fileChanged="onFileChange"
                /> -->
                <avatar-upload
                  ref="imgUpload"
                  :is-edit-mode="true"
                  @fileChanged="onFileChange"
                />
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <validation-provider rules="required|max:20" name="Mã sản phẩm">
                  <div class="das-form-input">
                    <div class="label required">Mã sản phẩm:</div>
                    <div class="child-w-80">
                      <input
                        v-model="productItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Việt:</div>
                    <div class="child-w-80">
                      <input v-model="productItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Anh:</div>
                    <div class="child-w-80">
                      <input v-model="productItem.eng_name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <validation-provider rules="required" name="Danh mục">
                  <div class="das-form-input">
                    <div class="label required">Danh mục:</div>
                    <input
                      v-show="false"
                      v-model="productItem.product_port_folio_id"
                    />
                    <VxTreeSelect
                      :options-tree="optionsTree"
                      :parent-data="productItem.product_port_folio_id"
                      @valueChange="dialogTreeDataChange"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <validation-provider
                  rules="required|max:50"
                  name="Đơn vị chính"
                >
                  <div class="das-form-input">
                    <div class="label required">Đơn vị chính:</div>
                    <el-select
                      v-model="productItem.product_cal_unit_id"
                      filterable
                      placeholder=""
                      @change="onMainUnitChanged"
                    >
                      <el-option
                        v-for="item in productCalOptions"
                        :key="item.id"
                        :label="`${item.unit} - ${item.name}`"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-4">
                <validation-provider rules="required|integer" name="Loại">
                  <div class="das-form-input">
                    <div class="label required">Loại:</div>
                    <el-select
                      v-model="productItem.type"
                      filterable
                      placeholder=""
                      @change="typeChange"
                    >
                      <el-option
                        v-for="item in productTypeOptions"
                        :key="item.id"
                        :label="`${item.code} - ${item.desc}`"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-4">
                <validation-provider rules="required|integer" name="Giá chung">
                  <div class="das-form-input">
                    <div class="label">Giá chung(VNĐ):</div>
                    <div class="child-w-80">
                      <VxCurrencyInput v-model="productItem.price" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-8">
                <div class="das-form-input">
                  <div class="checkbox-container">
                    <div class="checkbox-wrap">
                      <input
                        id="cpSpdTp3"
                        v-model="productItem.open_service"
                        type="checkbox"
                      />
                      <label for="cpSpdTp3">Là sản phẩm mở</label>
                    </div>
                    <div
                      v-if="
                        productItem.type == 111 ||
                        productItem.type == 112 ||
                        productItem.type == 113
                      "
                      class="checkbox-wrap"
                    >
                      <input
                        id="cpSpdTp4"
                        v-model="productItem.quick_purchase"
                        type="checkbox"
                      />
                      <label for="cpSpdTp4">Là sản phẩm mua hàng nhanh</label>
                    </div>
                    <div v-else class="checkbox-wrap">
                      <input
                        id="cpSpdTp4"
                        v-model="productItem.set_menu"
                        type="checkbox"
                      />
                      <label for="cpSpdTp4">Là Set Menu</label>
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="cpSpdTp5"
                        v-model="productItem.stop_using"
                        type="checkbox"
                      />
                      <label for="cpSpdTp5">Ngừng sử dụng</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <hr />
      <div
        v-if="productItem.set_menu"
        style="display: flex; justify-content: space-between"
      >
        <span>DANH SÁCH SẢN PHẨM THUỘC SET MENU</span>
        <button class="btn small primary" @click="addRow(1)">Thêm</button>
      </div>

      <div
        v-if="productItem.set_menu"
        class="grid-scroll mt-10"
        style="height: 200px"
      >
        <GridVx
          ref="agGrid1"
          :columns="setMenuCols"
          :auto-size-cell="true"
          :context="context"
          :rows="setMenuRows"
          dom-layout="scroll"
          class="agGrid"
        />
      </div>
      <div
        v-if="productItem.quick_purchase"
        style="display: flex; justify-content: space-between"
      >
        <span>DANH SÁCH ĐƠN VỊ QUY ĐỔI</span>
        <button class="btn small primary" @click="addRow(2)">Thêm</button>
      </div>
      <div
        v-if="productItem.quick_purchase"
        class="grid-scroll mt-10"
        style="height: 200px"
      >
        <GridVx
          ref="agGrid3"
          :columns="quickPurchaseCols"
          :auto-size-cell="true"
          :context="context"
          :rows="quickPurchaseRows"
          dom-layout="scroll"
          class="agGrid"
        />
      </div>
      <span>DANH SÁCH MENU</span>
      <div class="grid-scroll mt-10" style="height: 250px">
        <GridEnterprise
          ref="agGrid2"
          :columns="columnDefs"
          dom-layout="scroll"
          :rows="rowData"
          class="agGrid"
          :group-grid="true"
          :tree-data="true"
          :default-col-def="defaultColDef"
          :suppress-row-click-selection="true"
          :group-use-entire-row="false"
          :auto-group-column-def="autoGroupColumnDef"
          :get-data-path="getDataPath"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            Huỷ
          </button>
          <button
            v-if="!isEdit"
            class="btn primary small"
            @click="addNewProduct"
          >
            Tạo mới
          </button>
          <button v-else class="btn primary small" @click="updateProduct">
            Cập nhật
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import VxTreeSelect from '@/components/ui/VxTreeSelect.vue'
import FileInput from '@/components/ui/FileInput.vue'
import ProductSearch from './components/productSearch.vue'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import bus from '@/utils/bus'
import { downloadFile } from '@/utils/file-handler'
import { removeItemByName } from '@/vendor/subFunctions'
import {
  CellRenderInputSuggestion,
  CellRenderDeleteIcon,
  CellRenderTextInput,
  CellRenderSelect,
  CellRenderMultiLine
} from '@/utils/cellRenders.js'
import AvatarUpload from '@/components/ui/avatarUpload.vue'
import { getListProductType } from '@/api/common/code_base'
import { getListProductCategoryApi } from '@/api/configuration/accounting/product/productCategory.js'
import { getListProductUnitApi } from '@/api/configuration/accounting/product/unit.js'
import {
  addProductExcelApi,
  getProductExcelApi,
  getProductTemplateExcelApi,
  getListProductApi,
  addProductApi,
  updateProductApi,
  deleteProductApi
} from '@/api/configuration/accounting/product/product.js'
import { Message } from 'element-ui'
import CurrencyInput from '@/components/ui/currencyInput.vue'
import UploadByExcelComponent from './components/productUploadByExcel'
export default {
  components: {
    AvatarUpload,
    CellRenderInputSuggestion,
    CellRenderDeleteIcon,
    CellRenderTextInput,
    CellRenderSelect,
    CellRenderMultiLine,
    FileInput,
    CellRenderCheckboxReadonly,
    CurrencyInput,
    ProductSearch,
    VxTreeSelect,
    UploadByExcelComponent
  },
  data() {
    return {
      optionsTree: [],
      dfOptionsTree: [],
      selectedRows: [],
      errorExcelUploadRows: [],
      addListExcelDialogVisible: false,
      unitRowIndex: null,
      context: null,
      productSuggestionList: [],
      rowData: [],
      columnDefs: [],
      defaultColDef: [],
      businessDistrictOptions: [],
      productCategoryOptions: [],
      productTypeOptions: [],
      productCalOptions: [],
      // errorExcelUploadCols: [
      //   {
      //     headerName: 'Hàng',
      //     field: 'row_index',
      //     maxWidth: 80
      //   },
      //   {
      //     headerName: 'Mã sản phẩm',
      //     field: 'code',
      //     tooltipField: 'code',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Tên tiếng Việt',
      //     field: 'name',
      //     tooltipField: 'name',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Tên tiếng Anh',
      //     field: 'eng_name',
      //     tooltipField: 'eng_name',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Đơn vị chính',
      //     field: 'product_port_folio_code',
      //     tooltipField: 'product_port_folio_code',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Loại sản phẩm',
      //     field: 'code4',
      //     tooltipField: 'code4',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Mã danh mục',
      //     field: 'code4',
      //     tooltipField: 'code4',
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Giá chung',
      //     field: 'price',
      //     valueGetter: param => {
      //       return this.$displayCurrency(param?.data?.price) || null
      //     },
      //     maxWidth: 150
      //   },
      //   {
      //     headerName: 'Là sản phẩm mua hàng nhanh',
      //     field: 'quick_purchase'
      //   },
      //   {
      //     headerName: 'Là sản phẩm mở',
      //     field: 'is_open'
      //   },
      //   {
      //     headerName: 'Ngưng sử dụng',
      //     field: 'stop_using'
      //   },
      //   {
      //     headerName: 'Đơn vị chuyển đổi',
      //     field: 'product_cal_unit_unit'
      //   },
      //   {
      //     headerName: 'Mô tả lỗi',
      //     field: 'errorDetail',
      //     tooltipField: 'errorDetail',
      //     wrapText: true,
      //     minWidth: 500,
      //     autoHeight: true,
      //     cellStyle: { whiteSpace: 'pre' }
      //   }
      // ],
      quickPurchaseCols: [
        {
          headerName: 'Đơn vị chuyển đổi',
          field: 'product_cal_unit_id',
          maxWidth: 170,
          cellRenderer: 'CellRenderSelect',
          cellRendererParams: () => {
            return {
              options: this.productCalOptions.map(item => {
                return {
                  label: item.unit,
                  value: item.id
                }
              }),
              refName: 'product_cal_unit_id'
            }
          }
        },
        {
          headerName: 'Tỷ lệ chuyển đổi về đơn vị chính',
          field: 'convert_rate_unit',
          maxWidth: 250,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number',
              colName: 'convert_rate_unit'
            }
          }
        },
        {
          headerName: 'Phép tính chuyển đổi',
          field: 'calculation',
          maxWidth: 170,
          cellRenderer: 'CellRenderSelect',
          cellRendererParams: () => {
            return {
              options: [
                {
                  label: 'Phép nhân',
                  value: '*'
                },
                {
                  label: 'Phép chia',
                  value: '/'
                }
              ],
              refName: 'calculation'
            }
          }
        },
        {
          headerName: 'Mô tả',
          field: 'code4',
          tooltipField: 'code4'
        },
        {
          headerName: '',
          maxWidth: 80,
          cellRenderer: 'CellRenderDeleteIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'agGrid3'
            }
          }
        }
      ],
      setMenuCols: [
        {
          headerName: 'Mã',
          cellRenderer: 'CellRenderInputSuggestion',
          cellRendererParams: params => {
            return {
              productSuggestionList: this.productSuggestionList,
              code: params.data.code
            }
          },
          field: 'code'
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name'
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name'
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number'
            }
          }
        },
        {
          headerName: '',
          width: 80,
          cellRenderer: 'CellRenderDeleteIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'agGrid1'
            }
          }
        }
      ],
      setMenuRows: [],
      quickPurchaseRows: [],
      inputFile: null,
      productItem: {
        products: [],
        code: null,
        name: null,
        eng_name: null,
        product_port_folio_id: null,
        product_cal_unit_id: null,
        product_cal_unit_name: null,
        type: 114,
        price: 0,
        open_service: false,
        set_menu: false,
        stop_using: false,
        quick_purchase: false,
        menu_id: [],
        convert_units: []
      },
      searchShow: false,
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          width: 170
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name',
          width: 170
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name',
          width: 170
        },
        {
          headerName: 'Danh mục',
          field: 'product_port_folio_name',
          tooltipField: 'product_port_folio_name',
          width: 170
        },
        {
          headerName: 'Giá chung',
          field: 'price',
          valueGetter: param => {
            return this.$displayCurrency(param?.data.price) || null
          },
          tooltipField: 'price',
          width: 170
        },
        {
          headerName: 'Đơn vị',
          field: 'product_cal_unit_name',
          tooltipField: 'product_cal_unit_name',
          width: 170
        },
        {
          headerName: 'Loại',
          field: 'type_name',
          tooltipField: 'type_name',
          minWidth: 170,
          flex: 1
        },
        {
          headerName: 'Trạng thái',
          maxWidth: 100,
          valueGetter: param => {
            return !param.data.stop_using
          },
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center'
          // valueGetter: params => {
          //   if (params.data.stop_using) {
          //     return 'Không hoạt động'
          //   } else {
          //     return 'Hoạt động'
          //   }
          // }
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        productPortFolioID: null,
        productKeyWord: null,
        is_stop: null,
        productCalUnitId: null,
        businessDistrictId: null,
        type: null
      }
      // taxItem: {
      //   code: null,
      //   level: 0,
      //   desc: '',
      //   order: 0
      // }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
    // addListExcelDialogVisible() {
    //   this.addListExcelDialogVisible ? null : this.resetAddListExcelDialog()
    // }
  },
  beforeMount() {
    this.context = { componentParent: this }
    this.defaultColDef = { flex: 1 }
    this.columnDefs = [
      {
        field: 'Tên Menu',
        valueGetter: function (params) {
          return params.data.name
        }
      }
    ]
    this.autoGroupColumnDef = {
      headerName: 'Mã Menu',
      // headerCheckboxSelection: true,
      cellRendererParams: {
        // innerRenderer: true,
        // minWidth: 300,
        suppressCount: true,
        // suppressCount: true,
        checkbox: params => {
          return params.data.id !== 0
        }
        // innerRenderer: (params) => {
        //   return params.data.package_code
        // }
      }
    }
    this.getDataPath = data => {
      return data.code
    }
  },
  async mounted() {
    const data1 = await getListProductType()
    const data2 = await getListProductCategoryApi()
    this.dfOptionsTree = this.changeKeyNames(data2.data)
    const data3 = await getListProductUnitApi({ showNotActive: true })
    this.productTypeOptions = data1.data
    this.productCategoryOptions = data2.data
    this.productCalOptions = data3.data
    this.getBusinessDistrictOptions()
  },
  methods: {
    openUploadByExcelDialog() {
      this.$refs.uploadByExcelComponent.dialogFormVisile = true
    },
    changeKeyNames(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.changeKeyNames(item))
      }

      // If the object is an object, iterate over its key-value pairs
      const newObj = {}
      for (const key in obj) {
        // Change the key from 'code' to 'label'
        const newKey = key === 'name' ? 'label' : key
        const newKey1 = key === 'main_category_id' ? 'id' : key
        // Change the key from 'sub_transactions' to 'children'
        // Recursively process the value
        newObj[newKey] = this.changeKeyNames(obj[key])
        newObj[newKey1] = this.changeKeyNames(obj[key])
      }
      return newObj
    },
    dialogTreeDataChange(data) {
      this.productItem.product_port_folio_id = data
    },
    onReset(params) {
      this.searchParams.pageSize = 10
      Object.assign(this.searchParams, params)
      this.attachData()
    },
    onSearch(params) {
      Object.assign(this.searchParams, params)
      this.attachData()
    },
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    // async onSelectUploadList(data) {
    //   const file = data[0]
    //   this.$refs.uploadFile.resetFile()
    //   const formData = new FormData()
    //   formData.append('file', file)
    //   const array = []
    //   await addProductExcelApi(formData).then(res => {
    //     if (res.data) {
    //       res.data.forEach(item => {
    //         const errorList = item.list_error.map(item => {
    //           return `${this.$t(`product.${item.column_name}`)} ${this.$t(
    //             `errorMsg.${item.error_detail}`
    //           )}`
    //         })
    //         this.$message({
    //           message: this.$t('errorMsg.uploadNotSuccess'),
    //           type: 'error'
    //         })
    //         const errorJoined = errorList.join('\n')
    //         item.product_excel.errorDetail = errorJoined
    //         item.product_excel.rowIndex = item.list_error[0].rowIndex
    //         array.push(item.product_excel)
    //         this.errorExcelUploadRows = array
    //       })
    //     } else {
    //       if (res && res.message === 'importProductExcelFileSuccess') {
    //         this.$message({
    //           message: this.$t('successMsg.importProductExcelFileSuccess'),
    //           type: 'success'
    //         })
    //         this.addListExcelDialogVisible = false
    //         this.attachData()
    //       }
    //     }
    //   })
    //   // .catch(error => {
    //   //   alert(1)
    //   //   const message = error.response?.data?.message || 'default'
    //   //   this.$message({
    //   //     type: 'error',
    //   //     message: this.$t(`errorMsg.${message}`)
    //   //   })
    //   // })
    // },
    async downloadProductList() {
      bus.$emit('startLoader', { msg: '' })
      await getProductExcelApi()
        .then(res => {
          downloadFile(res, 'product_list.xlsx')
          const message = res.data?.message || 'default'
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    // async getListTemplate() {
    //   bus.$emit('startLoader', { msg: '' })
    //   await getProductTemplateExcelApi()
    //     .then(res => {
    //       downloadFile(res, 'product_template.xlsx')
    //       this.$message({
    //         message: 'Tải mẫu thành công',
    //         type: 'success'
    //       })
    //     })
    //     .catch(error => {
    //       const msg = error.response.data
    //       this.$message({
    //         message: this.$t(msg),
    //         type: 'error'
    //       })
    //     })
    //   bus.$emit('endLoader')
    // },
    // quickPurchaseRowClick() {
    // const gridApi = this.$refs.agGrid3.gridApi
    // const selectedNodes = gridApi.selectionService.selectedNodes
    // for (const property in selectedNodes) {
    //   if (selectedNodes[property]) {
    //     this.unitRowIndex = selectedNodes[property].rowIndex
    //     return;
    //   }
    // }
    // },
    typeChange() {
      this.productItem.quick_purchase = false
      this.productItem.set_menu = false
      this.setMenuRows = []
      this.quickPurchaseRows = []
    },
    setDataForUnitRow(mainUnitChanged = false) {
      const index = this.unitRowIndex
      if (
        this.quickPurchaseRows[index]['product_cal_unit_id'] &&
        this.quickPurchaseRows[index]['convert_rate_unit'] &&
        this.quickPurchaseRows[index]['calculation']
      ) {
        let donvichuyendoi, donvichinh, tilechuyendoi, phepquydoi, string
        this.$refs.agGrid3.gridOptions.api.forEachNode(node => {
          if (index == node.rowIndex && !mainUnitChanged) {
            donvichuyendoi = this.productCalOptions.filter(
              item => item.id == node.data['product_cal_unit_id']
            )[0].name
            donvichinh = this.productCalOptions.filter(
              item => item.id == this.productItem.product_cal_unit_id
            )[0].name
            tilechuyendoi = node.data['convert_rate_unit']
            phepquydoi = node.data['calculation']
            string = `1 ${donvichuyendoi} bằng ${donvichinh} ${phepquydoi} ${tilechuyendoi} `
            node.setDataValue('code4', string)
          }
          if (mainUnitChanged) {
            this.productCalOptions.filter(item => {
              if (node.data.product_cal_unit_id == item.id) {
                donvichuyendoi = item.name
              }
            })
            donvichinh = this.productCalOptions.filter(
              item => item.id == this.productItem.product_cal_unit_id
            )[0].name
            tilechuyendoi = node.data.convert_rate_unit
            phepquydoi = node.data.calculation
            string = `1 ${donvichuyendoi} bằng ${donvichinh} ${phepquydoi} ${tilechuyendoi} `
            node.setDataValue('code4', string)
          }
        })
      }
    },
    onMainUnitChanged() {
      this.setDataForUnitRow(true)
    },
    SelectInputChange(colName, params, value) {
      this.unitRowIndex = params.rowIndex
      const index = params.rowIndex
      this.quickPurchaseRows[index][colName] = value
      this.setDataForUnitRow()
    },
    addRow(data) {
      if (data == 1) {
        this.setMenuRows.push({
          code: null,
          eng_name: null,
          id: null,
          name: null,
          quantity: null
        })
      } else {
        if (!this.productItem.product_cal_unit_id) {
          this.$message({
            message: 'Phải chọn đơn vị chính trước',
            type: 'error'
          })
          return false
        }
        this.quickPurchaseRows.push({
          product_cal_unit_id: null,
          convert_rate_unit: null,
          calculation: null,
          code4: null
        })
      }
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      const agGrid = data.agGrid
      if (agGrid === 'agGrid1') {
        this.setMenuRows.splice(idx, 1)
      } else if (agGrid === 'agGrid3') {
        this.quickPurchaseRows.splice(idx, 1)
      }
    },
    textInputChange(params, data, colName) {
      this.unitRowIndex = params.rowIndex
      if (this.setMenuRows.length > 0) {
        this.setMenuRows[params.rowIndex].quantity = data
      }
      if (colName == 'convert_rate_unit') {
        this.quickPurchaseRows[params.rowIndex][colName] = data
        this.setDataForUnitRow()
      }
      // if (this.quickPurchaseRows[index]['product_cal_unit_id'] && this.quickPurchaseRows[index]['convert_rate_unit'] && this.quickPurchaseRows[index]['calculation']) {
      //   this.$refs.agGrid3.gridOptions.api.forEachNode(node => {
      //     let phepquydoi
      //     const donvichuyendoi = this.productCalOptions.filter(item => item.id == this.quickPurchaseRows[index]['product_cal_unit_id'])[0].name
      //     const donvichinh = this.productCalOptions.filter(item => item.id == this.productItem.product_cal_unit_id)[0].name
      //     const tilechuyendoi = this.quickPurchaseRows[index]['convert_rate_unit']
      //     this.quickPurchaseRows[index]['calculation'] == 'multiple' ? phepquydoi = '*' : phepquydoi = '/'
      //     const string = `1 ${donvichuyendoi} bằng ${donvichinh} ${phepquydoi} ${tilechuyendoi} `
      //     node.setDataValue('code4', string)
      //   });
      // }
    },
    suggestionInputChanged(index, data) {
      this.setMenuRows[index].code = data.code
      this.setMenuRows[index].name = data.name
      this.setMenuRows[index].eng_name = data.engName
      this.setMenuRows[index].id = data.id
      // this.$refs.agGrid1.gridOptions.api.setRowData(this.setMenuRows);
      this.$refs.agGrid1.gridOptions.api.forEachNode(node => {
        node.setDataValue('name', 'Vietnam')
      })
      // Change data in node :D
    },
    flattenNestedArray(arr, parentCodes = []) {
      return arr.flatMap(item => {
        const currentCodes = [...parentCodes, item.code]
        const flattenedItem = {
          code: currentCodes,
          name: item.name,
          id: item.id,
          mainCategoryId: item.mainCategoryId,
          engName: item.engName,
          inProduct: item.inProduct
        }

        if (item.children) {
          return [
            flattenedItem,
            ...this.flattenNestedArray(item.children, currentCodes)
          ]
        } else {
          return [flattenedItem]
        }
      })
    },
    getListByBusinessDistrict() {
      let id = null
      if (this.isEdit) {
        id = this.selectedRows[0].id
      }
      this.$axios
        .get('/config-service/v1/business-district-menu', {
          params: {
            productId: id
          }
        })
        .then(res => {
          this.rowData = this.flattenNestedArray(res.data)
        })
    },
    getBusinessDistrictOptions() {
      // businessDistrictOptions
      this.$axios
        .get('/config-service/v1/business-district/list-simple')
        .then(res => {
          this.businessDistrictOptions = res.data
        })
    },
    validateGridProduct() {
      let isValidated = true
      // setMenuRows check
      for (let i = 0; i < this.setMenuRows.length; i++) {
        let item = this.setMenuRows[i]
        if (!item.code || item.code === '') {
          this.$message({
            message: 'Thông tin mã Menu là bắt buộc',
            type: 'error'
          })
          isValidated = false
          break
        } else if (
          !item.quantity ||
          !Number(item.quantity) ||
          Number(item.quantity) < 1
        ) {
          this.$message({
            message: 'Thông tin số lượng không hợp lệ',
            type: 'error'
          })
          isValidated = false
          break
        }
      }
      // quickPurchaseRows check
      for (let i = 0; i < this.quickPurchaseRows.length; i++) {
        const item = this.quickPurchaseRows[i]
        if (!item.product_cal_unit_id || item.product_cal_unit_id === '') {
          this.$message({
            message: 'Thông tin đơn vị chuyển đổi không hợp lệ',
            type: 'error'
          })
          isValidated = false
          break
        } else if (
          !item.convert_rate_unit ||
          !Number(item.convert_rate_unit) ||
          Number(item.convert_rate_unit) < 1
        ) {
          this.$message({
            message: 'Tỷ lệ chuyển đổi không hợp lệ',
            type: 'error'
          })
          isValidated = false
          break
        } else if (!item.calculation || item.calculation === '') {
          this.$message({
            message: 'Phép tính chuyển đổi không hợp lệ',
            type: 'error'
          })
          isValidated = false
          break
        }
      }
      return isValidated
    },
    async addNewProduct() {
      if (!this.validateGridProduct()) {
        return
      }
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let setMenuRows, quickPurchaseRows
      if (this.productItem.set_menu) {
        const gridApi1 = this.$refs.agGrid1.gridApi
        setMenuRows = gridApi1.getSelectedRows()
        this.productItem.products = this.setMenuRows.map(item => {
          return {
            id: item.id,
            quantity: item.quantity
          }
        })
      }
      if (this.productItem.quick_purchase) {
        const gridApi3 = this.$refs.agGrid3.gridApi
        Object.assign(this.productItem.convert_units, this.quickPurchaseRows)
      }
      // menu_id table
      const gridApi2 = this.$refs.agGrid2.gridApi
      const errorExcelUploadRows = gridApi2.getSelectedRows()
      const menuIds = []
      errorExcelUploadRows.forEach(item => {
        menuIds.push(item.id)
      })
      this.productItem.menu_id = menuIds
      let formData = new FormData()
      formData.append('product', JSON.stringify(this.productItem))
      formData.append('picture', this.inputFile)
      this.$axios
        .post('/config-service/v1/product', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onFileChange(data) {
      this.inputFile = data
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    // onRefresh(data) {
    //   let params = {
    //     orderBy: data.orderBy,
    //     orderTp: data.sort
    //   }
    //   this.searchParams = { ...this.searchParams, ...params }
    //   this.attachData()
    // },
    resetInfo() {
      this.isEdit = false
      this.productItem = {
        products: [],
        code: null,
        name: null,
        eng_name: null,
        product_port_folio_id: null,
        product_cal_unit_id: null,
        type: 114,
        price: 0,
        open_service: false,
        set_menu: false,
        stop_using: false,
        quick_purchase: false,
        menu_id: [],
        convert_units: []
      }
      this.$refs.imgUpload.onResetImgSrc()
    },
    // resetAddListExcelDialog() {
    //   this.errorExcelUploadRows = []
    // },
    async openAddProductDialog() {
      // get select options
      await this.getListByBusinessDistrict()
      this.dialogFormVisible = true
      Object.assign(this.optionsTree, this.dfOptionsTree)
    },
    // CRUD
    // async addProduct() {
    //   if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
    //     return
    //   }
    //   let data = await addProductApi(this.taxItem)
    //   this.dialogFormVisible = false
    //   await this.attachData()
    //   this.$message({
    //     type: 'success',
    //     message: 'Bạn đã thêm loại sản phẩm thành công'
    //   })
    // },
    async editProduct() {
      this.isEdit = true
      await this.getListByBusinessDistrict()
      let array = []
      const row = this.selectedRows[0]
      array = JSON.parse(JSON.stringify(this.dfOptionsTree))
      removeItemByName(array, row.name)
      this.optionsTree = array
      this.dialogFormVisible = true
      //
      if (row.picture && !row.picture.includes('data:image/png;base64,')) {
        row.picture = 'data:image/png;base64,' + row.picture
      }
      this.productItem = row
      if (this.productItem.products) {
        Object.assign(this.setMenuRows, this.productItem.products)
      }
      if (this.productItem.convert_units) {
        this.quickPurchaseRows = this.productItem.convert_units.map(item => {
          return {
            ...item,
            code4: `1 ${item.product_cal_unit_name} bằng ${this.productItem.product_cal_unit_name} ${item.calculation} ${item.convert_rate_unit}`
          }
        })
      }
      setTimeout(() => {
        this.$refs.imgUpload.onSetImgSrc(row.picture)
      }, 200)
    },
    async deleteProduct() {
      const ids = this.selectedRows.map(item => item.id)
      this.$vxConfirm('Bạn chắc chắn muốn xoá loại sản phẩm này?', () => {
        deleteProductApi({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateProduct() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const id = this.selectedRows[0].id
      let setMenuRows, quickPurchaseRows
      if (this.productItem.set_menu) {
        const gridApi1 = this.$refs.agGrid1.gridApi
        setMenuRows = gridApi1.getSelectedRows()
        this.productItem.products = this.setMenuRows.map(item => {
          return {
            id: item.id,
            quantity: item.quantity
          }
        })
      }
      if (this.productItem.quick_purchase) {
        // const gridApi3 = this.$refs.agGrid3.gridApi
        // quickPurchaseRows = gridApi3.getSelectedRows()
        Object.assign(this.productItem.convert_units, this.quickPurchaseRows)
      }
      // menu_id table
      const gridApi2 = this.$refs.agGrid2.gridApi
      const errorExcelUploadRows = gridApi2.getSelectedRows()
      const menuIds = []
      errorExcelUploadRows.forEach(item => {
        menuIds.push(item.id)
      })
      //
      this.productItem.menu_id = menuIds
      this.productItem.products = this.setMenuRows.map(item => {
        return {
          id: item.id,
          quantity: item.quantity
        }
      })
      this.productItem.picture = null
      let formData = new FormData()
      formData.append('product', JSON.stringify(this.productItem))
      if (this.inputFile) {
        formData.append('picture', this.inputFile)
      }
      this.$axios
        .put(`/config-service/v1/product/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.dialogFormVisible = false
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListProductApi(this.searchParams)
      const dataForSelectOptions = await getListProductApi()
      this.loading = false
      this.rows = data.data
      const suggests = []
      dataForSelectOptions.data.forEach(item => {
        if (!item.stop_using) {
          suggests.push({
            value: item.name,
            name: item.name,
            engName: item.eng_name,
            code: item.code,
            id: item.id
          })
        }
      })
      Object.assign(this.productSuggestionList, suggests)
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.pageNum
      this.selectedRows = []
      //
    }
  }
}
</script>
